export interface QuotaCompanyDetailData {
    quotaType: QuotaType;
    max: number;
    consumed: number;
    available: number;
    unit: string;
}

export interface QuotaUserDetailData {
    quotaType: QuotaType;
    consumed: number;
    unit: string;
}

export interface QuotaConsumptionData {
    company: QuotaCompanyDetailData[];
    user: QuotaUserDetailData[];
}

export const QUOTA_TYPE = {
    NETWORK: 'NETWORK',
    STORAGE: 'STORAGE',
    USER: 'USER',
    PROCESSING: 'PROCESSING',
} as const;
export type QuotaType = (typeof QUOTA_TYPE)[keyof typeof QUOTA_TYPE];
